import { Collapsible } from '@/shared/components/ui/collapsible'
import {
    SidebarGroup,
    SidebarGroupContent,
    SidebarGroupLabel,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
    SidebarMenuSub,
    SidebarMenuSubButton,
    SidebarMenuSubItem,
} from '@/shared/components/ui/sidebar'
import { buildPathFromPattern, normalizePath } from '@/core/route-utils'
import { useLocation } from 'react-router-dom'

export type NavItemsSimpleProps = {
    name: string
    emoji: React.ReactNode
    routePattern?: string
    routeRegex?: RegExp
    onClick?: () => void
    subItems?: NavItemsSimpleProps[]
}
export type NavItemsSimpleComponentProps = {
    header: {
        title: string
        routePattern?: string
    }
    url_params?: Record<string, string | number>
    navItems: NavItemsSimpleProps[]
}
export function NavItemsSimple({ header, navItems, url_params }: NavItemsSimpleComponentProps) {
    const location = useLocation()
    const pathname = location.pathname
    const headerRoute = header.routePattern
        ? buildPathFromPattern(header.routePattern, url_params!)
        : undefined
    return (
        <SidebarGroup>
            <SidebarGroupLabel>
                <a href={headerRoute || '#'}>{header.title}</a>
            </SidebarGroupLabel>
            <SidebarGroupContent>
                <SidebarMenu>
                    {navItems.map((navItem) => {
                        const route = navItem.routePattern
                            ? buildPathFromPattern(navItem.routePattern, url_params!)
                            : undefined
                        return (
                            <Collapsible key={navItem.name}>
                                <SidebarMenuItem>
                                    <SidebarMenuButton
                                        asChild
                                        className={`${route == normalizePath(pathname) ? 'bg-muted' : ''
                                            }`}
                                    >
                                        {navItem.onClick ? (
                                            <button
                                                onClick={navItem.onClick}
                                                type="button"
                                                className="cursor-pointer "
                                            >
                                                <span>{navItem.emoji}</span>
                                                <span>{navItem.name}</span>
                                            </button>
                                        ) : route ? (
                                            <a href={route}>
                                                <span>{navItem.emoji}</span>
                                                <span>{navItem.name}</span>
                                            </a>
                                        ) : (
                                            <div>
                                                <span>{navItem.emoji}</span>
                                                <span>{navItem.name}</span>
                                            </div>
                                        )}
                                    </SidebarMenuButton>
                                    <SidebarMenuSub>
                                        {Object.entries(navItem.subItems || [])?.map(
                                            ([key, subItem]) => {
                                                const route = subItem.routePattern
                                                    ? buildPathFromPattern(
                                                        subItem.routePattern,
                                                        url_params!
                                                    )
                                                    : undefined
                                                return (
                                                    <SidebarMenuSubItem key={subItem.name}>
                                                        <SidebarMenuSubButton
                                                            asChild
                                                            className={`${route == normalizePath(pathname) ? 'bg-muted' : ''
                                                                }`}
                                                        >
                                                            <a href={route}>
                                                                <span>{subItem.emoji}</span>
                                                                <span>{subItem.name}</span>
                                                            </a>
                                                        </SidebarMenuSubButton>
                                                    </SidebarMenuSubItem>
                                                )
                                            }
                                        )}
                                    </SidebarMenuSub>
                                </SidebarMenuItem>
                            </Collapsible>
                        )
                    })}
                </SidebarMenu>
            </SidebarGroupContent>
        </SidebarGroup>
    )
}
